import styled from 'styled-components';

export const PaymentContainer = styled.div`
  margin-top: 32px;
`;

export const PixInfo = styled.div`
  border: 2px dashed #00D95F;
  border-radius: 12px;
  padding: 16px;
  margin-top: 16px;
  background: #F4FBF7;
`;

export const InfoItem = styled.p`
  margin: 10px 0;
  font-size: 14px;
  color: #18233A;
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    color: #00D95F;
    flex-shrink: 0;
  }
`;

export const CardForm = styled.div`
  margin-top: 20px;
  padding: 24px;
  background: #fff;
  border-radius: 16px;
  border: 1.5px solid #D9DDE3;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: 640px) {
    padding: 20px 16px;
  }
`;

export const CardInputField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 2px;
`;

export const Select = styled.select`
  width: 100%;
  height: 48px;
  padding: 0 16px;
  border: 1.5px solid #D9DDE3;
  border-radius: 10px;
  font-size: 15px;
  color: #18233A;
  outline: none;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;

  &:focus {
    border-color: #00D95F;
    box-shadow: 0 0 0 3px rgba(0, 217, 95, 0.1);
  }
`;

export const SaveCardCheckbox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 4px;
  padding: 8px 0;
`;

export const SecurityNote = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  background: #F4F5F7;
  border-radius: 12px;
  margin-top: 4px;

  svg {
    flex-shrink: 0;
    color: #00D95F;
    width: 18px;
    height: 18px;
  }

  span {
    font-size: 13px;
    color: #6b7280;
    line-height: 1.5;
  }
`;

export const AmazonPayBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 48px;
  padding: 0 20px;
  border-radius: 8px;
  border: none;
  background: #ff9900;
  color: #111;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #e68a00;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  img {
    height: 18px;
  }
`;